<template>
	<div class="WaiterSuccess">

		<!-- content start -->

		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<div class="align-container">
						<div class="align-container__item">
							<div class="waiter-success">
								<Lottie
									:options="defaultOptions"
									:height="400"
								/>

								<h3 class="waiter-success__title">Waiter has been Notified</h3>

								<button
									class="waiter-success__action"
									@click="$router.push({
										path: '/menu',
									})"
								>
									Continue
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- content end -->

	</div>
</template>

<script>
import Lottie from 'vue-lottie'

import * as animationData from '../assets/lottie/success.json'

export default {
	components: {
		Lottie,
	},

	data () {
		return {
			defaultOptions: {
				animationData: animationData.default,
				loop: false,
			},
		}
	},
}
</script>

<style lang="scss">
	.WaiterSuccess {
		.align-container {
			min-height: 100vh;
		}
	}

	.waiter-success {
		&__title {
			font-size: 18px;
			line-height: 22px;
			font-weight: 600;
			letter-spacing: -0.0241176em;
			margin: 0;
		}

		&__action {
			color: #FFF;
			display: inline-block;
			margin-top: 32px;
			border: none;
			border-radius: 10px;
			background: $blue;
			font-size: 18px;
			height: 56px;
			line-height: 56px;
			font-weight: 600;
			letter-spacing: -0.0241176em;
			padding: 0 15px;
			min-width: 173px;
		}
	}
</style>
